import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const Temperature = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            width={props.size}
            height={props.size}>
            <path d="M21 16.8C21 16.2477 20.5523 15.8 20 15.8C19.4477 15.8 19 16.2477 19 16.8L19 25.5495C17.6103 25.9765 16.6001 27.2703 16.6001 28.8C16.6001 30.6778 18.1223 32.2 20.0001 32.2C21.8779 32.2 23.4001 30.6778 23.4001 28.8C23.4001 27.2702 22.3898 25.9764 21 25.5494V16.8Z"
                fill={props.color ? props.color : "white"} />
            <path fillRule="evenodd" clipRule="evenodd"
                d="M20 4C17.2386 4 15 6.23858 15 9V24.1011C13.7639 25.3626 13 27.0927 13 29C13 32.866 16.134 36 20 36C23.866 36 27 32.866 27 29C27 27.0927 26.2361 25.3626 25 24.1011V9C25 6.23858 22.7614 4 20 4ZM16.6669 25.2729C16.8914 25.0721 17.0038 24.7927 16.9999 24.5134L17 24.5V9C17 7.34315 18.3431 6 20 6C21.6569 6 23 7.34315 23 9V24.5L23.0001 24.5134C22.9962 24.7927 23.1086 25.0721 23.3331 25.2729C24.3576 26.1899 25 27.5193 25 29C25 31.7614 22.7614 34 20 34C17.2386 34 15 31.7614 15 29C15 27.5193 15.6424 26.1899 16.6669 25.2729Z"
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default Temperature;
